import React from 'react';
import { Text } from 'react-native';

const Empty = () => <Text style={{ opacity: 0 }}>-</Text>;

export default Empty;